import { BitfGraphQlEnvelopeMapper } from '../graph-ql-parser/bitf-graph-ql-envelope.mapper';

export class BitfPimcoreEnvelopeMapper extends BitfGraphQlEnvelopeMapper {
  constructor() {
    super();
  }
}
